// @flow
import { Tab, Tabs } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { getRouteUrl } from "../../../../../../helpers/getRouteUrl";
import { normalizeGreek } from "../../../../../../helpers/normalizeGreek";
import { ROUTE_PAGE_EXHIBITION } from "../../../../../../routers/routes";

type Props = {};

const OrganizerTabs = (props: Props) => {
	const { section, id, t } = props
	return (
		<Tabs
			variant="scrollable"
			value={section}
			indicatorColor="primary"
			textColor="inherit"
			sx={{ marginTop: '20px' }}
		>
			<Tab
				component={Link}
				value={""}
				to={getRouteUrl(ROUTE_PAGE_EXHIBITION, { id })}
				label={normalizeGreek(t("Details"))}
			/>
			<Tab
				component={Link}
				value={"exhibitors"}
				to={getRouteUrl(ROUTE_PAGE_EXHIBITION, { id }, { section: "exhibitors" })}
				label={normalizeGreek(t("Exhibitors"))}
			/>
			<Tab
				component={Link}
				value={"visitors"}
				to={getRouteUrl(ROUTE_PAGE_EXHIBITION, { id }, { section: "visitors" })}
				label={normalizeGreek(t("Visitors"))}
			/>
			<Tab
				component={Link}
				value={"badges"}
				to={getRouteUrl(ROUTE_PAGE_EXHIBITION, { id }, { section: "badges" })}
				label={normalizeGreek(t("Quick Print Visitor Badges"))}
			/>
			{props.children}
		</Tabs>
	);
};

export default OrganizerTabs